module.exports = __webpack_public_path__ + "img/index_icon_5.88ea1c71.png";